<template>
  <div class="footerseo">
 
  
    <b-container fluid  v-if="footer_links!=null">
		<b-row>
		<b-col>
			<div class="desktop-popularSearch" ><div >
			<hr data-reactid="122"><div class="desktop-pSearchTitle" > POPULAR SEARCHES </div>
			<div class="desktop-pSearchlinks" v-html="footer_links" >
			<!-- v-bind:class="desktoppSearchlinks" v-html="footer_links" -->
				<!-- <a href="/sarees/minu-ready-to-wear-summer-green-printed-cotton-saree/1992/buy" target="_blank" >Printed Sarees </a>
				<a href="/sarees/saree/2269/buy" target="_blank" >Designer Sarees </a>
				<a href="/sarees/banani-cotton-saree/5357/buy" target="_blank" >Cotton Sarees  </a>
				<a href="/sarees/ikkat-cotton-saree-with-blouse-piece/8078/buy" target="_blank" >Kalamkari Sarees </a>
				<a href="/sarees/sea-green-chettinad-saree-with-ink-blue-ikat-blouse/7524/buy" target="_blank" >Art Silk Sarees</a>
				<a href="/sarees/peacock-in-village-kalamkari-saree/7494/buy" target="_blank" >Ikkat Cotton Sarees</a>
				<a href="/sarees/limited-edition-madhubani-hand-painted-pure-tussar-silk-sari-with-blouse-piece-unique-design-madhubani-sari/1195/buy" target="_blank" >Chettinad Sarees </a>
				<a href="/sarees/kora-organza-fashion-saree-with-blouse-piece/8299/buy" >Organza Sarees  </a>
				<a href="/sarees/beautifully-crafted-kota-tissue-saree-with-blouse-piece/6003/buy" >Tussar Silk Sarees </a>
				<a href="/sarees/pure-silk-saree-with-blouse-piece/5480/buy" >Floral Design Sarees</a>
				<a href="/sarees/total-dhamal-daily-wear-saree/5356/buy" >Kota Tissue Sarees </a>
				<a href="/sarees/kasturi-cotton-embroidery-saree/5322/buy" >Pure Silk Sarees </a>
				<a href="/sarees/tareza-embroidered-bollywood-art-silk-saree/4928/buy" >Daily Wear Sarees </a>
				<a href="/sarees/multicoloured-floral-saree/4254/buy" >Embroidery Saree  </a>
				<a href="/sarees/hand-block-printed-cotton-linen-sarees/3906/buy" >Cotton Linen Sarees  </a>-->
				
			</div>
			</div></div>
			
		</b-col>
		</b-row>
		
		
		
		
   </b-container>
   <b-container fluid  v-if="description!=null">
		<b-row>
		<b-col>
			<div class="desktop-popularSearch" ><div >
			<hr data-reactid="122"><div class="desktop-pSearchTitle" >&nbsp;</div>
			<small class="desktop-pSearchlinks" v-html="description" >						
			</small>
			</div></div>			
		</b-col>
		</b-row>
   </b-container>
			
  </div>
  
</template>

<script>

export default {
  name: 'Footerseo',
  components: {
    
	},
  props: {
    footer_links: String,
	description: String,
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
	desktoppSearchlinks:'desktop-pSearchlinks'
    }
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
  /*  .footer .footer-top{
     max-width: 90% !important;     
    margin-left: 10% !important;
    }
    .footerLinkul{
     padding: 0px !important;
    }
.footerLinkul li {
    display: block;
    margin: 0 0px !important;
    line-height: 24px;
    font-size: 0.9rem !important;
    text-align: left;
}*/

	.mpp{
		color: #ffffff !important;
		font-size: 13px;
	}
	.ppb{
		  border-right: 1px solid #c6c6c6;
	}
	
	
	.footerList li{ 
		padding: 0 5px 0 10px;
	}
	.footerseo{
	max-width: 87% !important;
    margin-left: 8% !important;
    margin-top: 29px;
	margin-bottom: 20px;
		
		h4{
		font-size: 15px;
		color: #535766;
		}
		.contentText{
			    font-size: 14px;
				color: #94969f;
				line-height: 19px;
		}
		li{
				font-size: 14px;
				color: #94969f;
				line-height: 19px;
				padding-top: 10px;
				list-style-type: auto;
		}


			.desktop-popularSearch hr {
			border: 1px;
			height: 1px;
			background-color: #eaeaec;
			}
			.desktop-pSearchTitle {
				position: absolute;
				margin-top: -24px;
				background: #f9f9f9;
				padding-right: 10px;
				color: #282c3f;
				font-size: 12px;
				font-weight: 500;
			}
			.desktop-pSearchlinks {
			margin-top: 2px;
			
			}
		.desktop-pSearchlinks>a {
		text-decoration: none;
		color: #696b79;
		font-size: 14px;
		line-height: 25px;
		}
		.desktop-pSearchlinks>a:after {
			content: "|";
			margin-left: 3px;
			margin-right: 3px;
		}
		.desktop-pSearchlinks>a:last-child:after {
			content: "";
		}
		
		
		
	}
	@media only screen and (max-width:640px) {
		.footerseo{
					.desktop-pSearchlinks {
					margin-top: 2px;
					overflow: scroll;
					}
				
			}
		
		}


</style>
